// extracted by mini-css-extract-plugin
export var active = "_d0-2";
export var recordingDot = "_d0-1";
export var recordingIndicator = "_d0-0";